'use strict';

require('../appIncludes.js');
require('./app.js');
require('./views/account.js');
require('./views/edit.js');
require('./views/unknownAccount.js');
require('./controller.js');
// NOTE require all the things so that we can access shared code like the connected FB/IG pages modal
require('../../dashboard/includes.js');
require('./bootstrap.js');
